import { ApiEndpoints } from "api/endpoints";
import { makeQuery } from "api/api";
import { ProfileSchema } from "model/profile/schema";

export const fetchUserProfile = async () => {
    const response = await makeQuery(ApiEndpoints.userProfile(), true);
    return ProfileSchema.parse(response.data);
};
